import { Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { comnUtils } from "@/comn/utils";
import { APIS, SF_VHCL_MDL_INFO } from "./services/OsciVhclMkerMgmtService";

/*
 * Vehicle Maker Model
 * !== 차량 제조사 모델 ==!
 */
export const OSCI0105007S = (props: any) => {
    const { pgeUid } = usePage({ pgeUid: "osci0105007s" });
    const modal = useModal();
    const toast = useToast();
    const { vhclMkerCd, vhclMdlCd, callback } = props;

    const form = {
        vhclMdlInfo: useForm({
            defaultSchema: SF_VHCL_MDL_INFO,
        }),
    };

    const fetch = {
        getVhclMdlInfo: useFetch({
            api: (data) => APIS.getVhclMdlInfo(vhclMkerCd, vhclMdlCd),
            enabled: !!vhclMdlCd,
            onSuccess: (data: any) => {
                form.vhclMdlInfo.setValues(data.vhclMdlInfo.content);
                form.vhclMdlInfo.setValue("mode", "MOD");
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        saveVhclMdlInfo: useFetch({
            api: (data: any) => APIS.saveVhclMdlInfo(data),
            enabled: false,
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00069", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    close: false,
                    onConfirm: () => {
                        callback();
                    },
                });
            },
            onError: (data) => {
                modal.openModal({ content: data.response.data.errorMessage }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                // toast.showToast({ type: "error", content: "msg.osc.00035" }), // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),
    };

    const handler = {
        saveVhclMdlInfo: () => {
            if (!comnUtils.isEmpty(form.vhclMdlInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.vhclMdlInfo.handleSubmit(
                () => {
                    form.vhclMdlInfo.setValue("vhclMkerCd", vhclMkerCd);
                    const data = form.vhclMdlInfo.getValues();
                    modal.openModal({
                        content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveVhclMdlInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
    };

    useEffect(() => {
        if (comnUtils.isEmpty(vhclMdlCd)) {
            form.vhclMdlInfo.setSchema("vhclMdlCd", { edit: true });
            form.vhclMdlInfo.setValue("mode", "NEW");
        } else {
            form.vhclMdlInfo.setSchema("vhclMdlCd", { edit: false });
            form.vhclMdlInfo.setValue("mode", "MOD");
        }
    }, []);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.vhclMdlInfo.schema.vhclMdlCd} />
                            <Group.Control {...form.vhclMdlInfo.schema.vhclMdlNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.vhclMdlInfo.schema.useYn} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
                <Layout>
                    <Layout.Right>
                        <Layout.Button role={"save"} onClick={handler.saveVhclMdlInfo} />
                    </Layout.Right>
                </Layout>
            </Group>
        </Page>
    );
};
